<template>
  <el-dialog
    title="物流信息"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
    @open="getDeliveryDetail"
  >
    <el-form
      :model="model"
      ref="form"
      label-width="100px"
      size="small"
      class="delivery"
    >
      <el-form-item label="物流公司：">
        <div>{{ logistic_company }}</div>
        <!-- <el-input :value="logistic_company"></el-input> -->
      </el-form-item>
      <el-form-item label="物流单号：">
        <div>
          {{ model.logistic_number }}
          <el-button
            style="margin-left: 10px"
            type="text"
            v-clipboard="model.logistic_number"
            @success="copySuccess()"
            >{{ copyText }}</el-button
          >
          <el-link
            v-if="query_url"
            style="margin-left: 10px; font-size: 12px"
            :href="query_url"
            type="primary"
            target="_blank"
            >查询</el-link
          >
        </div>
        <!-- <el-input :value="model.logistic_number"></el-input> -->
      </el-form-item>
      <el-form-item label="物流轨迹：" v-if="deliverInfo"> </el-form-item>
      <el-form-item label="" label-width="1px" v-if="deliverInfo">
        <div class="delivery-info" v-if="deliverInfo.LogisticCode">
          <div v-if="deliverInfo.Traces.length > 0" class="mt-20">
            <el-timeline :reverse="true">
              <el-timeline-item
                v-for="(activity, index) in deliverInfo.Traces"
                :key="index"
                :timestamp="activity.AcceptTime"
              >
                {{ activity.AcceptStation }}
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="font-12 text-center" v-else>{{ deliverInfo.Reason }}</div>
        </div>
        <div class="font-12 text-center" v-else>无物流信息</div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { logisticDetail } from '@/service/getData'

import VueClipboards from 'vue-clipboards'
import Vue from 'vue'
Vue.use(VueClipboards)

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.deliverInfo = null
      }
    },
  },
  data() {
    return {
      visible: this.show,
      logistic_company: '',
      query_url: '',
      deliverInfo: null,
      copyText: '复制',
    }
  },
  methods: {
    async getDeliveryDetail() {
      console.log(this.model)
      let res = await logisticDetail(this.model)
      if (res.status == 0) {
        this.logistic_company = res.req.logistic_company
        this.query_url = res.req.query_url
        if (res.data.LogisticCode) {
          this.deliverInfo = res.data
        }
      }
    },

    copySuccess(param) {
      this.copyText = '复制成功'
      let that = this
      setTimeout(function () {
        that.copyText = '复制'
      }, 1000)
    },
  },
}
</script>

<style>
.delivery .el-input.is-disabled .el-input__inner {
  color: #606266 !important;
}
</style>